import { useState, useCallback } from 'react';
import { pwn201Api } from '../../../services/pwn201Api';

export function usePWN201Navigation(loadRecord: (id: string) => Promise<void>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState<number>(-1);

  const loadList = useCallback(async () => {
    try {
      const res = await pwn201Api.list(1, 200);
      const ids = res.data.map((r) => r.fn110_01);
      setAllIds(ids);
      if (ids.length > 0) {
        setCurrentIdx(0);
        await loadRecord(ids[0]);
      }
    } catch {
      // silently fail
    }
  }, [loadRecord]);

  const navTo = useCallback(
    async (idx: number) => {
      if (idx < 0 || idx >= allIds.length) return;
      setCurrentIdx(idx);
      await loadRecord(allIds[idx]);
    },
    [allIds, loadRecord]
  );

  const navFirst = useCallback(() => navTo(0), [navTo]);
  const navPrev = useCallback(() => navTo(currentIdx - 1), [navTo, currentIdx]);
  const navNext = useCallback(() => navTo(currentIdx + 1), [navTo, currentIdx]);
  const navLast = useCallback(() => navTo(allIds.length - 1), [navTo, allIds.length]);

  return { allIds, currentIdx, loadList, navTo, navFirst, navPrev, navNext, navLast };
}
